import React, { useState } from 'react'
import Link from '../Link'
import * as styles from './index.module.css'
import useWindowSize from '../../hooks/useWindowSize'
import caret from '../../../static/caret.svg'

const Subnav = ({ components }) => {
  const size = useWindowSize()
  const [active, setActive] = useState(false)

  const toggleMenuSwitch = () => {
    setActive(!active)
  }

  return (
    <>
      {size.width > 500 && (
        <div>
          <div className={styles.desktopSubnav}>
            {components.map((component, idx) => {
              return (
                <Link to={component.ctaUrl} key={idx}>
                  {component.ctaText}
                </Link>
              )
            })}
          </div>
        </div>
      )}

      {size.width <= 500 && (
        <div>
          <div className={styles.mobileSidebarDesc} onClick={toggleMenuSwitch}>
            <span>On this page</span>
            <span className={active ? styles.rotateUp : styles.rotateDown}>
              <img src={caret} alt="caret" className={styles.caret} />
            </span>
          </div>

          <div
            className={active ? styles.mobileTopBarActive : styles.mobileTopBar}
          >
            <ul>
              {components.map((component, idx) => (
                <li key={idx}>
                  <Link
                    to={component.ctaUrl}
                    smooth={true}
                    offset={-135}
                    onClick={toggleMenuSwitch}
                  >
                    <span>{component.ctaText}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </>
  )
}

export default Subnav
